import React from 'react';
import { Box, Typography, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: theme.spacing(2),
  },
  loadingSpinner: {
    color: theme.palette.primary.main,
  },
}));

interface LoadingStateProps {
  title?: string;
  subtitle?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  title = 'Loading agents...',
  subtitle = 'Connecting to available AI agents',
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.loadingContainer}>
      <CircularProgress size={48} className={classes.loadingSpinner} />
      <Typography variant="h6" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {subtitle}
      </Typography>
    </Box>
  );
};